import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-b border-line bg-night px-4 py-14 sm:px-6 sm:py-20" data-id="element-98" data-mp="1gd7j2focfn96">
      <SectionHeading eyebrow="Questions fréquentes" title="Vos doutes, résolus" data-id="element-99" data-mp="2e0fwdne6xq03" />

      <ul className="mx-auto mt-10 flex w-full max-w-2xl flex-col gap-3" data-id="element-100" data-mp="2dy3jvpr7c7uf">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <li key={faq.q} className="overflow-hidden rounded-2xl border border-line bg-surface" data-id="element-101" data-mp="240fbvy4l53ub" data-mpi={index}>
              <h3 data-id="element-102" data-mp="1z2xd30ka8501">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-103" data-mp="1z5jhwsfsg6ek">
                  <span className="text-[15px] font-bold leading-snug text-white" data-id="element-104" data-mp="pipjnt59e328">{faq.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-lime transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-105" data-mp="ug9adsj588b2" />
                </button>
              </h3>
              {isOpen ? <p className="px-5 pb-5 text-[14px] leading-relaxed text-slate-400" data-id="element-106" data-mp="bhwrvg6cdm2t">{faq.a}</p> : null}
            </li>;
      })}
      </ul>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-107" data-mp="3swjz54rbotpi">
        <CTAButton label="Je veux résoudre mes doutes et commencer" caption="Téléchargement immédiat • Paiement unique • Garantie de 7 jours" data-id="element-108" data-mp="1rk7pp2fvux7" />
      </div>
    </section>;
}